import {UPDATE_KYC_PAYLOAD, SET_DEALER_PAN_NSDL_VERIFY, SET_DEALER_GSTN_VERIFY} from '../actionTypes';


export const mykyc = (kyc) => {
    return ({
        type: UPDATE_KYC_PAYLOAD,
        payload: {kyc}
    })
}

export const setDealerPanNSDLVerify = (isVerified) => ({
    type: SET_DEALER_PAN_NSDL_VERIFY,
    payload: isVerified,
});

export const setDealerGstnVerify = (isVerified) => ({
    type: SET_DEALER_GSTN_VERIFY,
    payload: isVerified,
});